

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Swal from 'sweetalert2';
import SignUpComponent from './SignUpComponent';

class OtpCustomerIdComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            serviceId: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value, verified: true })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }
    arrowIconClicked() {
        this.props.setLoginPage("pageName", "login");
    }


    // onVerify = recaptchaResponse => {
    //     this.setState({
    //         verified: true
    //     });
    // };

    fetchAccountDetails() {
        if (ValidateForm.inputFieldMandatoryCheck("otpCustomerIdContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("otpCustomerIdContainer", this.props.locales, false)) {
                var currentService = {}
                Network.executeAxios("fetchServiceInfoForPWL", "POST", { "serviceId": this.state.serviceId }, (fetchServiceInforesponse) => {
                    if (fetchServiceInforesponse && fetchServiceInforesponse.BillingSystem && fetchServiceInforesponse.BillingSystem.response &&
                        fetchServiceInforesponse.BillingSystem.response.dataset && fetchServiceInforesponse.BillingSystem.response.dataset.service_info) {
                        currentService = fetchServiceInforesponse.BillingSystem.response.dataset.service_info[0]
                    }

                    var profileId = ""
                    if (currentService && currentService.profile_id) {
                        profileId = currentService.profile_id
                    }

                    this.setState({ isLoading: true })
                    Network.executeAxios("forgetUsername", "POST", { "customerID": profileId }, (forgetUsernameResponse) => {
                        if (forgetUsernameResponse.STATUS === "SUCCESS") {
                            this.props.setUserRegisterDetails("customerId", profileId);
                            if (currentService.profile_info && currentService.profile_info[0]) {
                                var params = currentService.profile_info[0];
                                var profileContactNumber = "";
                                if (params && params.contact_number_1) {
                                    profileContactNumber = params.contact_number_1
                                }
                                var generatedOtp = Math.floor(Math.random() * 90000) + 10000;
                                var dataToSend = {
                                    otp: generatedOtp,
                                    contactNum: profileContactNumber
                                }
                                Network.executeAxios("otpAuth", "POST", dataToSend, (response) => {
                                    if (response.result_code && response.result_code === "0") {
                                        this.props.setUserRegisterDetails("profileContactNumber", profileContactNumber);
                                        this.props.setUserRegisterDetails("generatedOtp", generatedOtp);
                                        var isMobile = false;
                                        if (window.location.href.indexOf("mobile") > -1) {
                                            isMobile = true;
                                        }
                                        Network.executeAxios("loginWithOtp", "POST", { "profileId": profileId, "isMobile": isMobile }, (response) => {
                                            var retreivedUsername = forgetUsernameResponse.USERNAME;
                                            this.props.setForgetPasswordDetails("retreivedUsername", retreivedUsername);
                                            this.props.setLoginPage("pageName", "signInWithOTP");
                                        })
                                    } else {
                                        this.setState({ isLoading: false })
                                        Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                                    }
                                })
                            } else {
                                this.setState({ isLoading: false })
                                Swal.fire(this.props.locales.internalErrorInForgetPwdPageSwal, "", "");
                            }
                        } else if (forgetUsernameResponse.STATUS === "USER_NOT_EXIST") {
                            this.setState({ isLoading: false })
                            Swal.fire(this.props.locales.forgetUserNameInvalidCustomerIdSwal, "", "");
                        } else if (forgetUsernameResponse.STATUS === "FAILED") {
                            this.setState({ isLoading: false })
                            Swal.fire(this.props.locales.forgetUserNameOperationFailedSwal, "", "");
                        }
                    });
                })
            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.otpSignInComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    otpSignInComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="d-md-none col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-3 m-0 my-5 d-none d-sm-block">

                </div>

                <div className="col-md-12 row m-0 px-sm-3 px-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2" id="otpCustomerIdContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.signInWithOtptInOtpSignInCustomerIdPart}</div>
                        <div className="col-md-12 pb-4 pt-2" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.otpSendToMobileInOtpSignInCustomerIdPart}</div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.forgetPswUserNameCustmerIDLabel}</label>
                            <Input type="text" name="serviceId" autoComplete="new-password" style={{ color: '#404042' }}
                                className="loginCredItem input_data mandatoryFieldSpecial typeNumber pt-4 pb-3" placeholder={this.props.locales.customerIdInPlaceholderPart}
                                onChange={(event) => this.inputValueChange("serviceId", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>

                        <div className="col-md-12 pt-3">
                            <Button className="loginPageLoginButton" disabled={this.state.serviceId === "" ? true : false} onClick={() => { this.fetchAccountDetails() }}>
                                {this.props.locales.requestOtpBtnTextInOtpSignInPart}&nbsp; <FaArrowRight />
                            </Button>
                        </div>

                        <div className="d-flex pt-4 col-md-12 justify-content-center">
                            <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.signInLinkClicked() }}> {this.props.locales.singInOptionTextInSignInWithOtpPart}</div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    displayLabel(event) {
        event.target.previousSibling.classList.remove('d-none');
        event.target.placeholder = "";
    }

    signInLinkClicked() {
        this.props.setLoginPage("pageName", "login");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const OtpCustomerIdComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OtpCustomerIdComponent)


export default OtpCustomerIdComponentContainer;
